import React from 'react';

function ErrorDetails({ error }) {

	let errors;
	if (error.response) {
	  if (error.response.data.errors) {
		errors = error.response.data.errors.map(err => (<><em>Error: {err.message}</em> <br /></>));
	  } else {
		errors = (<> <em>Error: {error.response.data}</em> <br /> </>);
	  }
	} else if (error.request) {
	  errors = (<> <em>Error: {error.request}</em> <br /> </>);
	} else {
	  errors = (<> <em>Error: {error.message}</em> <br /> </>);
	}

	return (
	  <p className="mb-0 text-danger">
		<em>Status: {error.status}</em> <br />
		{errors}
	  </p>
	);
  }

  export default ErrorDetails;
